<template>
      <div id="addOrganization">
      <h3 class="text-center pt-5 text-info"></h3>
      <div class="container">
        <div id="addOrganization-row" class="row justify-content-center align-items-center">
          <div id="addOrganization-column" class="col-md-6">
            <div id="addOrganization-box" class="col-md-12">
              <form id="addOrganization-form" class="form" v-on:submit.prevent="addOrganization">
                <h3 class="text-center text-info">Add Organization</h3>

                <div class="form-group">
                  <label for="username" class="text-info" >New Organization Name:</label>
                  <br />
                  <input
                    type="text"
                    name="username"
                    id="username"
                    class="form-control"
                    v-model="organizationName"
                    placeholder="ex: hactiv8"
                  />
                </div>
                <div class="form-group">
                  
                </div>
                
                <div class="form-group">
                  <input type="submit" name="submit" class="btn btn-info btn-md" value="Save Organization" />
                  <a class="text-info" v-on:click="homePage()">Back to Home</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
    data(){
        return{

            organizationName:'',
        }
    },
    methods:{
        homePage(){
            this.$emit('homePage')
        },
        addOrganization(){
          let payload={
            name:this.organizationName,
          }
          this.$emit('addOrganization',payload)
        }
    }

}
</script>

<style>

</style>